import OneColumnCarousel from './OneColumnCarousel'


export default OneColumnCarousel
